<script>
import { mapActions } from 'vuex'

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { RadarChart } from 'echarts/charts'
import {
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  LegendScrollComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  DatasetComponent,
} from 'echarts/components'
import MChart, { THEME_KEY } from 'vue-echarts'

use([
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  LegendScrollComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  DatasetComponent,
  CanvasRenderer,
  RadarChart,
])
export default {
  components: {
    MChart,
  },
  props: {
    playerId: {
      type: Number,
      default: () => null,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      radarData: null,
      splitLineColor: 'rgba(0,0,0,.05)',
      splitAreaColor: ['rgba(250,250,250,0.035)', 'rgba(200,200,200,0.1)'],
      textColor: '#989898',
      labelBottom: {
        color: 'rgba(0,0,0,.2)',
        label: {
          show: false,
          position: 'center',
        },
        labelLine: {
          show: false,
        },
        emphasis: {
          color: 'rgba(0,0,0,.2)',
        },
      },
      option: {
        grid: {
          show: false,
          width: '200px',
          height: '150px',
        },
        tooltip: {
          show: false,
        },
        legend: {
          show: false,
          x: 'center',
          data: ['davide santon'],
          textStyle: {
            color: this.textColor,
          },
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {
              show: true,
              title: 'save as image',
            },
          },
        },
        calculable: true,
        radar: [
          {
            axisLine: {
              show: true,
              lineStyle: {
                // for both indicator and axisLine, bad, better seperate them
                color: '#b1b1b1',
              },
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(0,0,0,.1)',
              },
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: this.splitAreaColor,
              },
            },
            indicator: [
              {
                name: this.$t('radar_graph.Attack'),
                max: 1,
              },
              {
                name: this.$t('radar_graph.Goal'),
                max: 1,
              },
              {
                name: this.$t('radar_graph.Dribbling'),
                max: 1,
              },
              {
                name: this.$t('radar_graph.Technique'),
                max: 1,
              },
              {
                name: this.$t('radar_graph.Challenge'),
                max: 1,
              },
              {
                name: this.$t('radar_graph.Defense'),
                max: 1,
              },
              {
                name: this.$t('radar_graph.AirChallenges'),
                max: 1,
              },
              {
                name: this.$t('radar_graph.PassesPrecision'),
                max: 1,
              },
              {
                name: this.$t('radar_graph.KeyPasses'),
                max: 1,
              },
            ],
            radius: 60,
          },
        ],
        series: [
          {
            name: 'Full of live data',
            type: 'radar',
            itemStyle: {
              areaStyle: {
                type: 'default',
              },
            },
            data: null,
          },
        ],
      },
    }
  },
  provide: {
    [THEME_KEY]: 'light',
  },
  async created() {
    this.getPlayerStatData({ id: this.playerId })
      .then((response) => {
        const values = [
          response.radar.Attack,
          response.radar.Goal,
          response.radar.Dribbling,
          response.radar.Technique,
          response.radar.Challenge,
          response.radar.Defense,
          response.radar.AirChallenges,
          response.radar.PassesPrecision,
          response.radar.KeyPasses,
        ]

        this.option.series[0].data = [
          {
            value: values.map((value) => {
              return value < 0 ? 0 : value
            }),
            name: response.name,
          },
        ]
        this.loaded = true
        this.$emit('loaded', true)
      })
      .catch((error) => {
        console.error('Chart-Skill Player Compare Data fetch failed', error)
      })
  },
  methods: {
    ...mapActions('players', ['getPlayerStatData']),
    onResize() {
      if (typeof this.$refs.chart !== 'undefined') this.$refs.chart.resize()
    },
  },
}
</script>

<template>
  <v-responsive
    v-if="playerId !== null && playerId && loaded"
    v-resize="onResize"
    aspect-ratio="4/3"
    style="min-height: 15rem"
    :content-class="$style.contentClass"
  >
    <MChart v-if="loaded" ref="chart" :class="$style.chart" :option="option" />
  </v-responsive>
</template>

<style lang="scss" module>
@import '@design';

.chart {
  margin: 0 auto;
}

.contentClass {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
